import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { AppProviders } from './providers/AppProviders';
import logger from './utils/logger';

// Add global error handler
window.addEventListener("error", (event) => {
  logger.error("GLOBAL ERROR:", {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
  });
});

// Add unhandled promise rejection handler
window.addEventListener("unhandledrejection", (event) => {
  logger.error("UNHANDLED PROMISE REJECTION:", {
    reason: event.reason,
    promise: event.promise,
  });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);
